<template>
  <v-app class="login">
    <v-main v-if="$mq !== 'small' && $mq !== 'medium'">
      <v-container flex-column fill-height>
        <v-layout align-center>
          <apio-login-blurb v-if="!disableBlurb" />
          <component @login-section="loginSection" v-bind:is="loginSectionName"></component>
        </v-layout>
      </v-container>
    </v-main>
    <v-main v-else>
      <v-container>
          <component @login-section="loginSection" v-bind:is="loginSectionName"></component>
          <apio-login-blurb v-if="!disableBlurb" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "AccountLogin",
  data: () => ({
    email: "",
    password: "",
    nonBlurbScreens: [ 'registration', 'reset-password']
  }),
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    ResetPassword: () => import("@/pages/Account/ResetPassword.vue"),
    ResetPasswordForm: () => import("@/pages/Account/ResetPasswordForm.vue"),
    Login: () => import("@/pages/Account/LoginForm.vue"),
    ResetLinkSent: () => import("@/pages/Account/ResetLinkSent.vue"),
    Registration: () => import("@/pages/Account/Registration.vue"),
    ApioLoginBlurb: () => import("@/pages/Account/LoginBlurb.vue"),
  },
  computed: {
    loginSectionName() {
      return this.$route.query.section || "login"
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    disableBlurb() {
      return this.nonBlurbScreens.includes(this.$route.query.section)
    }
  },
  methods: {
    loginSection(section) {
      // this.loginSectionName = section;
      // section=reset-password
      this.$router.push("/pages/login?section=" + section)
    },
    async onSubmit() {
      const valid = await this.$refs.login.validate();
      valid ? this.login() : false;
    },
    login() {
      // Username is still used below as is what the backend requires at the moment
      this.$store.dispatch("login", {
        username: this.email,
        password: this.password,
      });
    },
  },
};
</script>

<style scoped lang="scss">

.v-application--wrap {
    min-height: 1px;
}

.form-field-error {
  display: flex;
  visibility: visible;
}

.login {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1440' height='1024' viewBox='0 0 1440 1024'%3E%3Cdefs%3E%3ClinearGradient id='7diaxdkd6b' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%233F51B5'/%3E%3Cstop offset='100%25' stop-color='%236A1B9A'/%3E%3C/linearGradient%3E%3Cpath id='6irawlzbqa' d='M0 0H1440V1024H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cmask id='7iuejdsfmc' fill='%23fff'%3E%3Cuse xlink:href='%236irawlzbqa'/%3E%3C/mask%3E%3Cuse fill='url(%237diaxdkd6b)' xlink:href='%236irawlzbqa'/%3E%3Cg style='mix-blend-mode:darken' mask='url(%237iuejdsfmc)'%3E%3Cg%3E%3Cpath fill='%231E88E5' d='M648.346 8.364L972.519 569.833 324.173 569.833z' transform='translate(-667 -11)'/%3E%3Cpath fill='%236200EA' d='M1296.691 8.364L1620.864 569.833 972.519 569.833z' transform='translate(-667 -11)'/%3E%3Cpath fill='%23A10070' d='M1620.864 569.833L1945.037 1131.303 1296.691 1131.303z' transform='translate(-667 -11)'/%3E%3Cpath fill='%233F51B5' d='M972.519 8.364L1296.691 569.833 648.346 569.833z' transform='translate(-667 -11) rotate(-180 972.519 289.098)'/%3E%3Cpath fill='%2329B6F6' d='M648.346 569.833L972.519 1131.303 324.173 1131.303z' transform='translate(-667 -11) rotate(-180 648.346 850.568)'/%3E%3Cpath fill='%236A1B9A' d='M1296.691 569.833L1620.864 1131.303 972.519 1131.303z' transform='translate(-667 -11) rotate(-180 1296.691 850.568)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
  background-size: cover;
}

.h3 {
  font-weight: normal;
  color: var(--apio-shade-2);
  margin-bottom: 40px;
}

.h1 {
  color: var(--apio-shade-2);
  margin-bottom: 8px;
}

.container {
  padding: 0;
}

.v-messages {
  position: absolute !important;
  top: -16px;
}

.v-input__prepend-inner {
  height: 16px !important;
}

.v-sheet--outlined {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-sheet.v-card {
  border-radius: 0;
  height: 439px;

  @media only screen and (max-width: 763px) {
    height: 100%;
    padding: 20px 20px;
    width: 100%;
  }
}


.auth-panel {
  width: 384px;
  height: 576px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &-mobile {
    width: 320px;
    margin: 40px 20px 0;
  }

  &--heading {
    margin: 0 0 16px 0;
  }

  &--sign-in {
    margin-top: 12px;
    width: 100%;
    text-transform: none;
  }

  &--get-started {
    margin-top: 12px;
    width: 100px;
    text-transform: none;
  }

  &--field {
    &-error {
      border: 1px solid var(--apio-error);
    }
  }

  &--form {
    position: relative;
    width: 305px;

    &-mobile {
      width: 320px;
    }

    &-title {
      margin-bottom: 16px;
    }

    &-group {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: stretch;
      width: 100%;
      position: relative;
      margin: 0 0 1rem 0;
    }

    &-error {
      position: absolute;
      left: 0;
      bottom: -1.2rem;
      color: #dc3545;
      font-size: 12px;
    }

    &-forgotten-password {
      color: var(--apio-purple);
      font-size: 12px !important;
      line-height: 1.33;
      height: 22px !important;
      padding: 0 !important;
      position: absolute;
      right: 0;
      top: -24px;
    }
  }

  &--logo {
    width: 90px;
    margin-bottom: 8px;
    display: block;
  }
}
</style>
